import type { ReactNode } from 'react';

export function AppShell({ children }: { children: ReactNode }): JSX.Element {
  return (
    <div
      className="h-screen w-screen flex grid-bg"
      style={{ background: 'transparent', color: 'rgb(var(--fg))' }}
      data-testid="app-shell"
    >
      {children}
    </div>
  );
}
